exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./node_modules","./node_modules/grommet/node_modules"]}!./src/App.scss
// module id = 167
// module chunks = 0